import {Component, Input, OnInit} from '@angular/core';
import {GtManageOrganizationService} from '@app/services/gt-manage-organization.service';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {CallCauseUtil} from '../utils/call-cause';
import {RedirectEntry} from '../utils/redirect-entry';

@Component({
  selector: 'gt-redirect-history',
  templateUrl: './redirect-history.component.html',
  styleUrls: ['./redirect-history.component.scss']
})
export class RedirectHistoryComponent implements OnInit {
  @Input() redirectEntries: RedirectEntry[];
  selectedRedirectEntry: RedirectEntry;

  constructor(private directoryService: GtDirectoryService, private manageService: GtManageOrganizationService) {}

  ngOnInit() {
    if (this.redirectEntries) {
      this.redirectEntries.forEach(entry => {
        if (!entry.name) {
          this.setEntryName(entry);
        }
      });
    }
  }

  private setEntryName(entry) {
    this.directoryService.getContactByFullNumber(this.manageService.manageOname, entry.phonenumber).subscribe(
      contact => {
        entry.name = contact.name; // It will go to error if no contact is found.
      },
      () => {
        this.getServiceNums(entry);
      }
    );
  }

  private getServiceNums(entry) {
    this.directoryService
      .getServiceNumber(entry.phonenumber, this.manageService.manageOname, this.manageService.manageLogin)
      .subscribe(serviceNumber => {
        entry.name = serviceNumber ? serviceNumber.name : '';
      });
  }

  getCssClass(entry: RedirectEntry) {
    if (CallCauseUtil.isCallAnswered(entry.callCause)) {
      return 'color-green';
    } else if (CallCauseUtil.isAAbandon(entry.callCause)) {
      return 'color-red';
    } else if (CallCauseUtil.isCallMissed(entry.callCause)) {
      return 'color-red';
    } else {
      return 'color-yellow';
    }
  }
}
